import { useLocation } from "react-router-dom";

//used to get query params from the url
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export { useQuery };
